'use client';
import React from 'react';
import CioAutocompleteProvider from '../CioAutocompleteProvider';
import AutocompleteResults from '../AutocompleteResults/AutocompleteResults';
import SearchInput from '../SearchInput/SearchInput';
export default function CioAutocomplete(props) {
    const { children } = props;
    if (children) {
        return React.createElement(CioAutocompleteProvider, { ...props }, children);
    }
    return (React.createElement("div", null,
        React.createElement(CioAutocompleteProvider, { ...props },
            React.createElement(SearchInput, null),
            React.createElement(AutocompleteResults, null))));
}
